<template>
  <div style="margin-top: 50px">
    <card :data="systemApps" @click="systemIcoClick">
      <template slot="header">
        <mt-header>
          <mt-button slot="left">
            <img
              src="@/assets/website.png"
              height="20"
              width="20"
              slot="icon"
            />
            系统设置
          </mt-button>
        </mt-header>
      </template>
    </card>
  </div>
</template>

<script>
import card from "@/components/IconsCard.vue";
import Vue from "vue";
export default Vue.extend({
  components: {
    card,
  },
  mounted() {
  },
  created() {
    var userInfo = this.appApi.getUserData();
    //console.log(userInfo.hasRoles)
    this.user = userInfo;
    if (this.user) {
      //网站管理
      if (this.user.hasRoles.isAdmin) {
        this.systemApps.push({
          icon: "el-icon-chat-line-round",
          iconcolor: "#db9e3f",
          title: "系统参数",
          url: "Parameter",
          isCompoent: true,
        });
      }

      if (
        this.user.hasRoles.isAdmin ||
        this.user.hasRoles.isSuper ||
        this.user.hasRoles.isManager
      ) {
        this.systemApps.push({
          icon: "el-icon-edit-outline",
          iconcolor: "#db9e3f",
          title: "密码设置",
          url: "Password",
          isCompoent: true,
        });
      }
      this.systemApps.push({
        icon: "el-icon-info",
        iconcolor: "#db9e3f",
        title: "关于",
        url: "About",
        isCompoent: true,
      });
    }
  },
  data() {
    return {
      user: "",
      systemApps: [],
      countApps: [],
    };
  },
  methods: {
    systemIcoClick(data) {
      if (data.isCompoent) {
        this.$router.push({ name: data.url });
      }
    },
    countIcoClick(data) {
      if (data.isCompoent) {
        this.$router.push({ name: data.url });
      }
    },
  },
});
</script>

<style lang="less" scoped>
</style>